import React, { useState, useEffect } from "react";
import cssClasses from "./ChangePriceModal.module.css";
import {
  Box,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../Subcomponents/Button";
import DropDown from "../../../Subcomponents/DropDown";
import CustomInput from "../../../Subcomponents/CustomInput";
import {
  getAllPlansByProjectFromFarvision,
} from "../../../Services/PaymentPlans";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import { errorTost, successTost } from "../../../Services/Toast";
import {
  insertCRMLogs,
  updateAllotmentPayment,
  updateCrmAllotment,
  getParkingUpgradeCost,
  getJdBuIdForUnit,
} from "../../../Services/AllAllotments";
import { deriveAgreementValues, toNumber } from "./parkingUpgradeUtil";
import { useSelector } from "react-redux";
import ConfirmationAlert from "../../../Subcomponents/ConfirmationAlert";
import { updateInventory } from "../../../Services/Inventory";
import { bucketingForChangeUnit, approveParkingUpgradeViaApi } from "../../../Services/PaymentApi";
import GstPercentageChange from "../CrmAllotment/GSTPercentageChange/GstPercentageChange"
import { min, reject } from "lodash";

function ChangePriceModal({ open, handleClose, crmAllotmentObject, tabName, sdrPercentage, legalCharges, registrationCharges, btnName }) {
  console.log("crmAllotmentObject", crmAllotmentObject);

  // console.log("BTN-Name", btnName);

  const loggedInUser = useSelector((state) => state.Auth.user);

  const isChangeAV = crmAllotmentObject?.crm_status_id === 1;
  const isApprovalPending = crmAllotmentObject?.crm_status_id === 3;
  const showParking = isChangeAV || isApprovalPending;

  const [newBspPrice, setNewBspPrice] = useState(
    // Change AV starts blank (base falls back to the current agreement value);
    // other tabs prefill the submitted agreement value as before.
    isChangeAV ? "" : (crmAllotmentObject?.new_unit_cost?.bsp || "")
  );
  const [selectedNewPaymentPlan, setSelectedNewPaymentPlan] = useState(
    crmAllotmentObject?.new_payment_plan || ""
  );
  // Approval Pending: keep the approver's remark field empty (their own note);
  // the submitter's Change AV note is shown read-only below.
  const [remarks, setRemarks] = useState(isApprovalPending ? "" : (crmAllotmentObject?.remarks || ""))
  const [skipChangesValues, setSkipChangesValues] = useState(false);
  const [ocrPercentage, setOcrPercentage] = useState(0)
  const [paymentPlans, setPaymentPlans] = useState(null);
  const [approveConfirmationAlertToggle, setApproveConfirmationAlertToggle] =
    useState(false);
  // const [bspApproveMsg,setBspApproveMsg] = useState("")
  const [showConfirmationMsg, setShowConfirmationMsg] = useState("")
  const [gstPercentage, setGstPercentage] = useState(
    Number(crmAllotmentObject?.unitcost?.gst) === 0 ? 0 : Number((crmAllotmentObject?.new_unit_cost?.bsp === "") ? crmAllotmentObject?.unitcost?.bsp : crmAllotmentObject?.new_unit_cost?.bsp) < 4500000 ? 1 : 5);
  const [gstConfirmationModal, setGstConfirmationModal] = useState(false);
  const [gstPercentageChangeModal, setGstPercentageChangeModal] = useState(false);
  const [parkingUpgrade, setParkingUpgrade] = useState("");
  const [storedParking, setStoredParking] = useState(0);
  const [submitterRemark, setSubmitterRemark] = useState(crmAllotmentObject?.remarks || "");
  useEffect(() => {
    getAllPlansByProjectFromServer();
    // Approval Pending: parking is editable and the request-raiser's remark must
    // be shown, so read both straight from the CRM row (the list RPCs return
    // neither). Split the stored parking back out of the submitted combined value.
    if (isApprovalPending && crmAllotmentObject?.id) {
      getParkingUpgradeCost(crmAllotmentObject.id)
        .then((res) => {
          setSubmitterRemark(res?.data?.remarks || "");
          const sp = toNumber(res?.data?.parkingUpgradeCost);
          if (sp > 0) {
            setStoredParking(sp);
            setParkingUpgrade(String(sp));
            const combined = toNumber(crmAllotmentObject?.new_unit_cost?.bsp);
            setNewBspPrice(String(Math.max(combined - sp, 0)));
          }
        })
        .catch((err) => console.log("getParkingUpgradeCost failed", err));
    }
  }, []);

  // useEffect(() => {
  //   let str = ((crmAllotmentObject?.paidamt?.ocr * 100) / (newBspPrice === "" ? crmAllotmentObject?.unitcost?.bsp : newBspPrice))
  //   str = str.toString()
  //   str = str.slice(0, (str.indexOf(".")) + 2 + 1)
  //   setOcrPercentage(Number(str))
  //   // setGstPercentage(Number(crmAllotmentObject?.unitcost?.gst) === 0 ? 0 : Number(newBspPrice ? newBspPrice : crmAllotmentObject?.unitcost?.bsp) < 4500000 ? 1 : 5)
  //   const gstZero = Number(crmAllotmentObject?.unitcost?.gst) === 0;

  //   if (gstZero) {
  //     setGstPercentage(0);
  //   } else {
  //     const bspVal =
  //       newBspPrice === "" || newBspPrice === undefined
  //         ? Number(crmAllotmentObject?.unitcost?.bsp)
  //         : Number(newBspPrice);

  //     if (bspVal < 4500000) {
  //       setGstPercentage(1);
  //     } else if (crmAllotmentObject?.isCommercial === true) {
  //       setGstPercentage(12);   // ⭐ COMMERCIAL → 12%
  //     } else {
  //       setGstPercentage(5);    // Non-Commercial → 5%
  //     }
  //   }

  // }, [newBspPrice])

    useEffect(() => {
  const effective = showParking
    ? getEffectiveBsp()
    : (newBspPrice === "" ? Number(crmAllotmentObject?.unitcost?.bsp) : Number(newBspPrice));
  let str = ((crmAllotmentObject?.paidamt?.ocr * 100) / (effective || crmAllotmentObject?.unitcost?.bsp));
  str = str.toString();
  str = str.slice(0, (str.indexOf(".")) + 2 + 1);
  setOcrPercentage(Number(str));

  const gstZero = Number(crmAllotmentObject?.unitcost?.gst) === 0;

  if (gstZero) {
    setGstPercentage(0);
  } else {
    const bspVal = effective;

    if (crmAllotmentObject?.isCommercial === true) {
      // COMMERCIAL → from ProjectAdditionalConfiguration.gstPercentage
      // (applies regardless of price), falling back to 12% if not yet configured
      setGstPercentage(Number(crmAllotmentObject?.gstPercentage ?? 12));
    } else if (bspVal < 4500000) {
      setGstPercentage(1);   // Non-Commercial below ₹45L → 1%
    } else {
      setGstPercentage(5);   // Non-Commercial above ₹45L → 5%
    }
  }
}, [newBspPrice, parkingUpgrade, storedParking]);


  async function getAllPlansByProjectFromServer() {
    try {
      presentLoader();
      let projectId = null;
      let _buId = null;
      if (crmAllotmentObject) {
        projectId = crmAllotmentObject?.project_id;
        _buId = crmAllotmentObject?.bu_id;
      } else {
        projectId = crmAllotmentObject?.project_id;
        _buId = crmAllotmentObject?.bu_id;
      }

      // JD units (Inventory.jdBuId set) fetch plans from the JD Farvision API with the JD buId
      const jdBuId = crmAllotmentObject?.unit_id
        ? await getJdBuIdForUnit(crmAllotmentObject.unit_id)
        : null;

      // const getAllPlansByProjectResponse = await getAllPlansByProject(projectId); //! Supabase Query
      await getAllPlansByProjectFromFarvision(jdBuId ?? _buId, jdBuId ? false : undefined).then((getAllPlansByProjectResponse) => {
        if (
          getAllPlansByProjectResponse?.data &&
          getAllPlansByProjectResponse?.data?.result
        ) {
          setPaymentPlans([...getAllPlansByProjectResponse.data.result]);
          dismissLoader();
        } else {
          throw getAllPlansByProjectResponse;
        }
      }).catch((err) => {
        console.log(err);
        throw err;
      });
    } catch (error) {
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else if (error?.response?.data?.message) {
        errorTost(error.response.data.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      dismissLoader();
    }
  }

  // The base agreement value (without parking). A blank New Value keeps the
  // current agreement value; otherwise we use what was typed.
  function getBaseAV() {
    return newBspPrice !== "" && newBspPrice !== undefined && newBspPrice !== null
      ? toNumber(newBspPrice)
      : toNumber(crmAllotmentObject?.old_unit_cost?.bsp);
  }

  // In Change AV / Approval Pending, route the cost calc through the combined
  // agreement value (base + parking). In every other context, behaves as before.
  function getEffectiveBsp() {
    if (showParking) {
      return deriveAgreementValues({ baseValue: getBaseAV(), newParking: parkingUpgrade }).effectiveAV;
    }
    return Number(newBspPrice);
  }

  // Short contextual note shown when the agreement value and/or parking change.
  function parkingNoteText() {
    if (!showParking) return "";
    const parkingAdded = toNumber(parkingUpgrade) > 0;
    // No note for a plain agreement-value change — keep the original behaviour.
    if (!parkingAdded) return "";
    const baseChanged = getBaseAV() !== toNumber(crmAllotmentObject?.old_unit_cost?.bsp);
    return baseChanged
      ? "The parking cost is added to the new agreement value. GST, SDR and total unit cost are calculated on the combined Total Agreement Value."
      : "The parking cost is added to the current agreement value. GST, SDR and total unit cost are calculated on the combined Total Agreement Value.";
  }

  function calculateSdr() {
    return (Math.ceil((Math.round((getEffectiveBsp() * (sdrPercentage)) / 100)) / 100) * 100) +
      (getEffectiveBsp() > 3000000
        ? (Math.ceil(Number(registrationCharges / 100) * 100))
        : (Math.ceil(Number(getEffectiveBsp() / 100) / 100) * 100)) +
      legalCharges
      ;
  }

  function calculateGst() {
    return Math.round((getEffectiveBsp() * gstPercentage) / 100);
  }

  // function calculateTotal() {
  //   return Math.round(
  //     Number(newBspPrice) +
  //     (Math.ceil((Math.round((Number(newBspPrice) * (sdrPercentage)) / 100)) / 100) * 100) +
  //     (Number(newBspPrice) > 3000000
  //       ? (Math.ceil(Number(registrationCharges / 100) * 100))
  //       : (Math.ceil(Number(newBspPrice / 100) / 100) * 100)) +
  //     legalCharges +
  //     (Number(newBspPrice) < 4500000
  //       ? Number(newBspPrice) / 100
  //       : (Number(newBspPrice) * gstPercentage) / 100)
  //   )
  // }
  function calculateTotal() {
  return Math.round(
    getEffectiveBsp() +
    (Math.ceil((Math.round((getEffectiveBsp() * (sdrPercentage)) / 100)) / 100) * 100) +
    (getEffectiveBsp() > 3000000
      ? (Math.ceil(Number(registrationCharges / 100) * 100))
      : (Math.ceil(Number(getEffectiveBsp() / 100) / 100) * 100)) +
    legalCharges +
    // gstPercentage state already resolves to the correct rate (commercial
    // override or the 1%/5% non-commercial rule) — see calculateGst()
    calculateGst()
  )
}

  async function changePriceSubmitHandler(isUnitCostUpdate = false) {
    let postBody = {};
    postBody.requestPendingWith = crmAllotmentObject?.crmuserid;
    // The AV value has changed
    if (!skipChangesValues) {
      // ! add it in seperate fun
      postBody.requestPendingWith = crmAllotmentObject?.crm_status_id === 1 ? loggedInUser?.parentId?.userId : crmAllotmentObject?.crmuserid;
      postBody.newUnitCost = {
        bsp: Math.round(getEffectiveBsp()),
        sdr: calculateSdr(),
        gst: calculateGst(),
        total: calculateTotal(),
      };
      if (showParking) {
        postBody.parkingUpgradeCost = toNumber(parkingUpgrade);
      }
      postBody.isChangeableValue = true;
      crmAllotmentObject?.crm_status_id === 1 ? postBody.crmStatusId = process.env.REACT_APP_APPROVAL_PENDING : postBody.crmStatusId = process.env.REACT_APP_UPDATE_SDR;
      postBody.last_updated_at = Date.now();
      if (crmAllotmentObject?.crm_status_id === 3) {
        postBody.isApproved = true;
      }
      postBody.newPaymentPlan = selectedNewPaymentPlan;
      postBody.sdrPercentage = sdrPercentage;
      // Approval Pending: the approver's note goes to approvalRemark so it
      // never overwrites the request-raiser's remark on the CRM row.
      if (isApprovalPending) {
        postBody.approvalRemark = remarks;
      } else {
        postBody.remarks = remarks;
      }
    } else if (!crmAllotmentObject?.is_changeable_value) {
      postBody.isApproved = true;
      postBody.crmStatusId = process.env.REACT_APP_UPDATE_SDR;
      postBody.last_updated_at = Date.now();
      postBody.newPaymentPlan = selectedNewPaymentPlan;
      // Approval Pending: the approver's note goes to approvalRemark so it
      // never overwrites the request-raiser's remark on the CRM row.
      if (isApprovalPending) {
        postBody.approvalRemark = remarks;
      } else {
        postBody.remarks = remarks;
      }
    }

    if (
      (crmAllotmentObject?.rejection_reason &&
        crmAllotmentObject?.is_reject_changes) && (crmAllotmentObject?.crmStatusId === process.env.REACT_APP_APPROVAL_PENDING || skipChangesValues === true)
    ) {
      postBody.rejectionReason = "";
      postBody.isRejectChanges = false;
      postBody.newUnitCost = null;
      postBody.newPaymentPlan = null;
      postBody.parkingUpgradeCost = null;
      postBody.approvalRemark = null;
    } else if (crmAllotmentObject?.is_changeable_value && !isUnitCostUpdate) {
      postBody.isApproved = true;
      postBody.crmStatusId = process.env.REACT_APP_UPDATE_SDR;
      postBody.last_updated_at = Date.now();
    }

    if (tabName !== "Changed Plan" && crmAllotmentObject?.old_unit_cost?.bsp === Number(newBspPrice) && crmAllotmentObject?.paidamt?.ocr > (crmAllotmentObject?.unitcost?.bsp * 10) / 100) {
      postBody.isApproved = true
      postBody.crmStatusId = process.env.REACT_APP_UPDATE_SDR;
      postBody.last_updated_at = Date.now();
    }

    console.log("Postbody", postBody);
    try {
      presentLoader();
      //AV Approved by Head (In Approval Pending Tab)
      if (postBody?.isApproved && crmAllotmentObject?.crm_status_id === 3) {
        if (
          postBody.newUnitCost &&
          postBody?.newUnitCost?.bsp &&
          (postBody?.newUnitCost?.gst || postBody?.newUnitCost?.gst === 0) &&
          postBody?.newUnitCost?.sdr &&
          postBody?.newUnitCost?.total
        ) {
          // Parking-upgrade approvals run server-side: the backend performs the
          // same writes and then triggers the customer feedback-form link, whose
          // API key must not ship in the browser bundle. Every other AV approval
          // keeps the inline path below untouched.
          if (toNumber(parkingUpgrade) > 0) {
            const approveResp = await approveParkingUpgradeViaApi({
              crmAllotmentId: crmAllotmentObject?.id,
              userName: loggedInUser?.name,
              approvalRemark: remarks,
              newUnitCost: postBody.newUnitCost,
              // The endpoint overrides isApproved / crmStatusId / newUnitCost /
              // approvalRemark itself; the rest of the modal's computed pricing
              // fields ride along unchanged.
              crmUpdate: postBody,
            });
            if (!approveResp?.data?.success) {
              throw new Error(approveResp?.data?.message || "Parking upgrade approval failed");
            }
            successTost("AV submitted successfully!");
            dismissLoader();
            handleClose(true);
            return;
          }
          const approveCrmUpdatePostBody = {
            unitCost: {
              bsp: postBody.newUnitCost.bsp,
              sdr: postBody.newUnitCost.sdr,
              gst: postBody.newUnitCost.gst,
              total: postBody.newUnitCost.total,
            },
          };

          const updateInventoryObj = {
            BSP: postBody.newUnitCost.bsp,
            GST: postBody.newUnitCost.gst,
            SDR: postBody.newUnitCost.sdr,
            totalCost: postBody.newUnitCost.total,
          };
          //Allotment Payment Table Update
          await updateAllotmentPayment(approveCrmUpdatePostBody, crmAllotmentObject?.allotment_payment_id).then(async (updateAllotmentPaymentResponse) => {
            await updateInventory(updateInventoryObj, crmAllotmentObject?.unit_id).then(async (updateInventoryResponse) => {
              console.log("updateInventoryResponse", updateInventoryResponse);
              //CRM Table Update
              await updateCrmAllotment(postBody, crmAllotmentObject?.id).then(async (updateCrmAllotmentResponse) => {
                let bucketingObj = {
                  allotmentPaymentId: crmAllotmentObject?.allotment_payment_id,
                };
                //Bucketing Applied
                await bucketingForChangeUnit(bucketingObj).then((bucketingResp) => {
                  if (updateCrmAllotmentResponse.data && updateCrmAllotmentResponse?.data?.id) {
                    successTost("AV submitted successfully!");
                    if (crmAllotmentObject?.crm_status_id === 3) { //Approval Pending //Approved AV Changed Value 
                      const crmObj = {
                        message: `AV Approved for allotment unit ${crmAllotmentObject?.unit_no} of project ${crmAllotmentObject?.project_name} by ${loggedInUser?.name} for ${remarks}`,
                        allotmentPaymentId: crmAllotmentObject?.allotment_payment_id,
                        crmStatus: "AV Approval done"
                      }
                      insertCRMLogs(crmObj).then(async (res) => {
                        console.log("Logs saved", res);

                      }).catch((err) => {
                        console.log(err);
                      })
                    }
                    dismissLoader();
                    handleClose(true);
                  } else {
                    throw updateCrmAllotmentResponse;
                  }
                }).catch((err) => {
                  console.log(err);
                  throw err;
                });
              }).catch((err) => {
                console.log(err);
                throw err;
              });
            }).catch((err) => {
              console.log(err);
              throw err;
            });
          }).catch((err) => {
            console.log(err);
            throw err;
          });
        }
      }
      else {
        //Skip Changes or Changed AV (In Changed AV Tab)
        await updateCrmAllotment(postBody, crmAllotmentObject?.id).then(async (updateCrmAllotmentResponse) => {
          let bucketingObj = {
            allotmentPaymentId: crmAllotmentObject?.allotment_payment_id,
          };
          //Bucketing Applied
          await bucketingForChangeUnit(bucketingObj).then((bucketingResp) => {
            if (updateCrmAllotmentResponse.data && updateCrmAllotmentResponse?.data?.id) {
              // CRM log for the parking-cost entry (Change AV submission).
              if (crmAllotmentObject?.crm_status_id === 1 && !skipChangesValues && toNumber(parkingUpgrade) > 0) {
                insertCRMLogs({
                  message: `Parking upgrade cost of ₹${numberWithCommas(toNumber(parkingUpgrade))} added for allotment unit ${crmAllotmentObject?.unit_no} of project ${crmAllotmentObject?.project_name} by ${loggedInUser?.name}.`,
                  allotmentPaymentId: crmAllotmentObject?.allotment_payment_id,
                  crmStatus: "Parking upgrade added",
                }).catch((err) => console.log("parking log failed", err));
              }
              if (postBody?.isApproved) {
                successTost("AV submitted successfully!");
                if (crmAllotmentObject?.crm_status_id === 1) { //Change AV
                  const crmObj = {
                    message: `AV for allotment unit ${crmAllotmentObject?.unit_no} of project ${crmAllotmentObject?.project_name} is not changed by ${loggedInUser?.name} for ${remarks} with payment plan : ${selectedNewPaymentPlan.Description}`,
                    allotmentPaymentId: crmAllotmentObject?.allotment_payment_id,
                    crmStatus: "AV not changed"
                  }
                  insertCRMLogs(crmObj).then(async (res) => {
                    console.log("Logs saved", res);
                  }).catch((err) => {
                    console.log(err);
                  })
                }
              } else {
                //Change AV Tab
                successTost("AV changed successfully!");
                const crmObj = {
                  message: `AV is changed from ${crmAllotmentObject?.old_unit_cost?.total} to ${postBody?.newUnitCost?.total} for allotment unit ${crmAllotmentObject?.unit_no} of project ${crmAllotmentObject?.project_name} by ${loggedInUser?.name} for ${remarks} with payment plan : ${selectedNewPaymentPlan.Description} `,
                  allotmentPaymentId: crmAllotmentObject?.allotment_payment_id,
                  crmStatus: "AV Changed"
                }
                insertCRMLogs(crmObj).then(async (res) => {
                  console.log("Logs saved", res);
                  const crmObj2 = {
                    message: `AV Approval for allotment unit ${crmAllotmentObject?.unit_no} of project ${crmAllotmentObject?.project_name} is pending with ${loggedInUser?.parentId ? loggedInUser?.parentId?.name : loggedInUser?.name}`,
                    allotmentPaymentId: crmAllotmentObject?.allotment_payment_id,
                    crmStatus: "AV Approval pending"
                  }
                  const avApprovalPending = await insertCRMLogs(crmObj2);
                }).catch((err) => {
                  console.log(err);
                })
              }
              dismissLoader();
              handleClose(true);
            } else {
              throw updateCrmAllotmentResponse;
            }
          }).catch((err) => {
            console.log(err);
            throw err;
          });
        }).catch((err) => {
          console.log(err);
          throw err;
        });
      }
    } catch (error) {
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else if (error?.message) {
        errorTost(error?.message);
      } else {
        errorTost(error);
      }
      dismissLoader();
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={[
          {
            ".MuiBackdrop-root": {
              background: "rgba(193, 201, 210, 0.7)",
            },
          },
        ]}
        disableAutoFocus={true}
      >
        <Box className={cssClasses.modalWrapper}>
          <div className={cssClasses.header}>
            {/* <img src={MessageIcon} alt="" /> */}
            <h1>Change Plan</h1>
            {/* <img src={crossImage} alt="" style={{cursor:"pointer"}} onClick={handleClose}/> */}
            <IconButton
              className={cssClasses.crossButton}
              onClick={handleClose}
            >
              {" "}
              <CloseIcon />{" "}
            </IconButton>
          </div>

          <div className={cssClasses.mainContainer}>
            <table className={cssClasses.tableClass}>
              <tbody>
                <tr>
                  <td></td>
                  <td>
                    <Typography sx={[{ ...labelStyle, textAlign: "center" }]}>
                      Old Value
                    </Typography>
                  </td>
                  <td>
                    <Typography sx={[{ ...labelStyle, textAlign: "center" }]}>
                      New Value
                    </Typography>
                  </td>
                  {/* <td><Typography sx={[{...labelStyle, textAlign: "center"}]}>Skip&nbsp;Changes</Typography></td> */}
                </tr>
                <tr>
                  <td>
                    <Typography
                      sx={[
                        {
                          ...labelStyle,
                          color: "#000",
                          fontWeight: 600,
                          marginBottom: 0,
                        },
                      ]}
                    >
                      Agreement Value
                    </Typography>
                  </td>
                  <td>
                    <CustomInput
                      inputType="text"
                      value={crmAllotmentObject?.old_unit_cost?.bsp}
                      handleChange={(_value) => {
                      }}
                      // helperText={helperText.name}
                      disabled={true}
                    />
                  </td>
                  <td>
                    <CustomInput
                      inputType="text"
                      value={newBspPrice}
                      handleChange={(_value) => {
                        if (!isNaN(_value)) {
                          setNewBspPrice(_value);
                        }
                      }}
                      disabled={skipChangesValues || btnName === "Preview"}
                    />
                  </td>
                </tr>
                {showParking && (
                  <>
                    <tr>
                      <td>
                        <Typography sx={[{ ...labelStyle, color: "#000", fontWeight: 600, marginBottom: 0 }]}>
                          Parking Upgrade
                        </Typography>
                      </td>
                      <td>
                        <CustomInput inputType="text" value={0} handleChange={() => { }} disabled={true} />
                        <div style={{ height: "20px", padding: "2px" }}></div>
                      </td>
                      <td>
                        <CustomInput
                          inputType="text"
                          value={parkingUpgrade}
                          handleChange={(_value) => { if (!isNaN(_value)) setParkingUpgrade(_value); }}
                          disabled={skipChangesValues || btnName === "Preview"}
                        />
                        <div style={{ height: "20px", padding: "2px" }}></div>
                      </td>
                    </tr>
                    {parkingNoteText() !== "" && (
                      <tr>
                        <td colSpan={3}>
                          <div style={{ display: "flex", gap: "8px", fontSize: "12.5px", color: "#3f6bd8", background: "#eef3ff", borderRadius: "5px", padding: "7px 10px", lineHeight: 1.35, alignItems: "flex-start" }}>
                            <span style={{ fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0 }}>Note</span>
                            <span>{parkingNoteText()}</span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                )}
                <tr>
                  <td>
                    <Typography
                      sx={[
                        {
                          ...labelStyle,
                          color: "#000",
                          fontWeight: 600,
                          marginBottom: 0,
                        },
                      ]}
                    >
                      Payment Plan
                    </Typography>
                  </td>
                  {crmAllotmentObject?.old_payment_plan?.payment_plan_id
                    ?.title && (
                      <td>
                        <CustomInput
                          inputType="text"
                          value={
                            crmAllotmentObject?.old_payment_plan?.payment_plan_id
                              ?.title
                          }
                          handleChange={(_value) => { }}
                          // helperText={helperText.name}
                          disabled={true}
                        />
                      </td>
                    )}
                  <td
                    colSpan={
                      crmAllotmentObject?.old_payment_plan?.payment_plan_id
                        ?.title
                        ? 0
                        : 2
                    }
                  >
                    {paymentPlans?.length === 0 ? (
                      <Typography sx={[{ ...labelStyle, marginBottom: 0 }]}>
                        No Payment Plan
                      </Typography>
                    ) : (
                      <DropDown
                        list={
                          paymentPlans
                            ? paymentPlans?.map((m) => ({
                              label: m?.Description,
                              value: m?.Id,
                            }))
                            : []
                        }
                        selectedValue={selectedNewPaymentPlan.Id}
                        onChangeSelect={(_value) => {
                          let _paymentPlan = paymentPlans.find(
                            (f) => f.Id === _value
                          );
                          setSelectedNewPaymentPlan(_paymentPlan);
                        }}
                        // ! changed after 'skip changes' moved for all inputs
                        disable={skipChangesValues || btnName === "Preview"}
                      // disable={skipChangesValues?.paymentPlan}
                      // helperText={selectedCrmUserHelperText}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              style={{
                display: "flex",
                gap: "1rem",
                flexDirection: "column",
                fontSize: "1.8rem",
                padding: "10px",
                background: "var(--gray-50, #F9FAFB)",
                borderRadius: "10px",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              {/* tabName === "Changed Plan" &&  */}
              {<div
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  justifyContent: "space-between",
                  paddingBottom: "1rem",
                  borderBottom: "1px solid rgba(217, 217, 217, 1)"
                }}
              >
                <span style={{ fontWeight: 600 }}>OCR ({ocrPercentage}%) :</span>
                <span style={{ fontFamily: "inter-semibold", fontWeight: 600 }}>
                  ₹
                  {numberWithCommas(crmAllotmentObject?.paidamt?.ocr)}
                </span>
              </div>}
              {showParking ? (
                (() => {
                  const av = deriveAgreementValues({ baseValue: getBaseAV(), newParking: parkingUpgrade });
                  const baseUnchanged = getBaseAV() === toNumber(crmAllotmentObject?.old_unit_cost?.bsp);
                  return (
                    <>
                      <div style={{ display: "flex", gap: "0.5rem", justifyContent: "space-between" }}>
                        <span style={{ fontWeight: 600 }}>
                          Agreement Value (Without Parking) :
                          {baseUnchanged && (
                            <span style={{ fontWeight: 500, fontSize: "12.5px", color: "#8a91a0", marginLeft: 6 }}>(unchanged, from Old Value)</span>
                          )}
                        </span>
                        <span>₹{numberWithCommas(Math.round(av.baseAV))}</span>
                      </div>
                      <div style={{ display: "flex", gap: "0.5rem", justifyContent: "space-between" }}>
                        <span style={{ fontWeight: 600 }}>Parking Upgrade :</span>
                        <span>₹{numberWithCommas(Math.round(av.parking))}</span>
                      </div>
                      <div style={{ display: "flex", gap: "0.5rem", justifyContent: "space-between", paddingTop: "6px", borderTop: "1px dashed #dfe3ec" }}>
                        <span style={{ fontWeight: 700 }}>Total Agreement Value :</span>
                        <span style={{ fontWeight: 700 }}>₹{numberWithCommas(Math.round(av.effectiveAV))}</span>
                      </div>
                    </>
                  );
                })()
              ) : (
                <div
                  style={{
                    display: "flex",
                    gap: "0.5rem",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Agreement Value :</span>
                  <span>
                    ₹
                    {(newBspPrice !== '') ? numberWithCommas(Math.round(+newBspPrice)) : numberWithCommas(crmAllotmentObject?.old_unit_cost?.bsp)}
                  </span>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  GST ({gstPercentage}%) :
                </span>
                <span>
                  ₹
                  {(showParking || newBspPrice !== '') ? numberWithCommas(
                    calculateGst()
                  ) : numberWithCommas(crmAllotmentObject?.old_unit_cost?.gst)}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ fontWeight: 600 }}>SDR ({sdrPercentage}%) + Fee :</span>
                <span>
                  ₹
                  {(showParking || newBspPrice !== '') ? numberWithCommas(
                    calculateSdr()
                  ) : numberWithCommas(crmAllotmentObject?.old_unit_cost?.sdr)}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ fontWeight: 600 }}>Total Unit Cost :</span>
                <span>
                  ₹
                  {(showParking || newBspPrice !== '') ? numberWithCommas(
                    calculateTotal()
                  ) : numberWithCommas(crmAllotmentObject?.old_unit_cost?.total)}
                </span>
              </div>
            </div>

            <div>
              <table className={cssClasses.tableClass}>
                <tbody>
                  {isApprovalPending && submitterRemark && (
                    <tr>
                      <td>
                        <Typography sx={[{ ...labelStyle, color: "#000", fontWeight: 600, marginBottom: 0 }]}>
                          Change AV Note
                        </Typography>
                      </td>
                      <td>
                        <div style={{ fontSize: "13px", color: "#475467", padding: "6px 2px", whiteSpace: "pre-wrap" }}>
                          {submitterRemark}
                        </div>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Typography
                        sx={[
                          {
                            ...labelStyle,
                            color: "#000",
                            fontWeight: 600,
                            marginBottom: 0,
                          },
                        ]}
                      >
                        Remark
                      </Typography>
                    </td>
                    <td>
                      <CustomInput
                        inputType="text"
                        value={remarks}
                        handleChange={(_value) => {
                          setRemarks(_value);
                        }}
                      // helperText={helperText.name}
                      // disabled={true}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className={cssClasses.footer}>
            {btnName === "Preview" ?
              (<div>
                <Button
                  style={{ color: '#344054', backgroundColor: '#FFFFFF', }}
                  btnName={"Close"}
                  clicked={() => {
                    handleClose(true);
                  }}
                />
              </div>)
              : (<>
                {crmAllotmentObject?.crm_status_id === 1 &&
                  <div>
                    <Button
                      // style={{ color: "#344054", backgroundColor: "#ffffff" }}
                      style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
                      btnName={"Skip Changes"}
                      clicked={() => {
                        setSkipChangesValues(!skipChangesValues);

                        if (tabName !== "Changed Plan") {
                          setNewBspPrice("");
                        } else {
                          setNewBspPrice(
                            crmAllotmentObject?.new_unit_cost?.bsp
                          );
                        }
                        setShowConfirmationMsg("Do you want to skip the changes and proceed?")
                        setApproveConfirmationAlertToggle(true);
                      }}
                      disable={!selectedNewPaymentPlan || !remarks}
                    ></Button>
                  </div>
                }
                <div>
                  <Button
                    style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
                    btnName={"Approve"}
                    disable={(!skipChangesValues ? !Boolean((paymentPlans?.length === 0 ? true : Boolean(selectedNewPaymentPlan)) && (newBspPrice || (isChangeAV && toNumber(parkingUpgrade) > 0))) : false) || !remarks}
                    clicked={() => {
                      crmAllotmentObject?.crm_status_id === 3
                        ? setGstConfirmationModal(true)
                        : setApproveConfirmationAlertToggle(true);
                    }}
                  />
                </div></>)}
          </div>
        </Box>
      </Modal>


      {gstConfirmationModal && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              setGstConfirmationModal(false);
              setApproveConfirmationAlertToggle(true);
            }
            if (e === "rejected") {
              setGstPercentageChangeModal(true);
            }
          }}
          buttonTitle={"No"}
          returnRespButton={"Yes"}
          close={() => {
            setGstConfirmationModal(false);
          }}
          title={"Warning"}
          // subTitle={`Would you prefer to retain the current GST% i.e 
          //           ${Number(crmAllotmentObject?.unitcost?.gst) === 0 ? '0%' : Number((newBspPrice === "") ? crmAllotmentObject?.unitcost?.bsp : newBspPrice) < 4500000 ? "1%" : "5%"} ?`}

  //         subTitle={`Would you prefer to retain the current GST% i.e 
  // ${Number(crmAllotmentObject?.unitcost?.gst) === 0
  //             ? "0%"
  //             : Number(
  //               newBspPrice === ""
  //                 ? crmAllotmentObject?.unitcost?.bsp
  //                 : newBspPrice
  //             ) < 4500000
  //               ? "1%"
  //               : crmAllotmentObject?.isCommercial
  //                 ? "12%"
  //                 : "5%"
  //           } ?`}
   subTitle={`Would you prefer to retain the current GST% i.e
  ${gstPercentage}% ?`}

          open={gstConfirmationModal}
        />
      )}

      {gstPercentageChangeModal && <GstPercentageChange
        open={true}
        handleClose={() => {
          setGstPercentageChangeModal(false);
        }}
        allotment={crmAllotmentObject}
        sdrPercentage={sdrPercentage}
        setApproveConfirmationAlertToggle={setApproveConfirmationAlertToggle}
        newBspPrice={newBspPrice}
        legalCharges={legalCharges}
        registrationCharges={registrationCharges}
        handleSubmit={(newGst) => {
          setGstPercentage(newGst);
        }}
      />}

      {/* Approve Confirmation Alert  */}
      {approveConfirmationAlertToggle && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              changePriceSubmitHandler();
            }
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => {
            setSkipChangesValues(!skipChangesValues);
            setApproveConfirmationAlertToggle(false);
          }}
          title={"Warning"}
          subTitle={showConfirmationMsg !== "" ? showConfirmationMsg : `Are you sure! Do you want to approve CRM changes?`}
          open={approveConfirmationAlertToggle}
        />
      )}
    </>
  );
}

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}

export default ChangePriceModal;
const labelStyle = {
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "20px",
  color: "#344054",
  marginBottom: "0.8rem",
};